import { HbsGenerator } from '../components/hbs/Generator';

export default function GeneratorPage(): JSX.Element {
  return (
    <div className="p-9 max-w-2xl mx-auto">
      <h1 className="font-display font-semibold text-[32px] tracking-hbs-tight text-hbs-text mb-1">
        Password generator
      </h1>
      <p className="text-[15px] text-hbs-text-mute mb-6">
        Make a strong password, then save it back to your safe.
      </p>
      <HbsGenerator />
    </div>
  );
}
